import { render } from "./SignDrawCanvas.vue?vue&type=template&id=47890af4"
import script from "./SignDrawCanvas.vue?vue&type=script&lang=js"
export * from "./SignDrawCanvas.vue?vue&type=script&lang=js"

import exportComponent from "/home/ec2-user/environment/links-frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__